import PropTypes from "prop-types"
import { useState } from "react"
import useApiAction from "hooks/use_api_action"

export default function TriggerCheckistrationsResyncButton({ event }) {
  const [disabled, setDisabled] = useState(false)
  const resyncAction = useApiAction({
    path: `events/${event.id}/trigger_checkistrations_resync`
  })

  return (
    <button
      onClick={() => {
        setDisabled(true)
        resyncAction.run().then(() => setDisabled(false))
      }}
      className="staff-only btn2 sm-btn"
      disabled={disabled}
    >
      Resync with Check-Ins
    </button>
  )
}

TriggerCheckistrationsResyncButton.propTypes = {
  event: PropTypes.shape({ id: PropTypes.number })
}
